<template>
  <a-modal
    centered
    title="添加物品"
    v-model="visible"
    @ok="submitGoods"
    @cancel="visible = false"
    :maskClosable="false"
    width="800px"
  >
    <data-table ref="dataTable" :option="option"> </data-table>
  </a-modal>
</template>
<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      visible: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.option = {
        //搜索框内容
        headSearch: {
          colnum: 1,
          content: [
            {
              label: "物品名称",
              name: "Keyword"
            }
          ],
          onSubmitBefore: values => {
            return values;
          }
        },
        //表格内容
        grid: {
          api: "Warehouse_GoodsList", //数据表格api
          params: {
            IsForBinding: true,
            Status: 1
          },
          columns: [
            {
              title: "序号",
              width: "10%", //宽度
              align: "center", //对齐方式
              type: "indexcolumn" // 类型，indexcolumn = 序号
            },
            {
              title: "物品名称",
              dataIndex: "Name",
              align: "center"
            },
            {
              title: "物品代码",
              dataIndex: "Code",
              width: "20%",
              align: "center"
            },
            {
              title: "物品分类",
              dataIndex: "CategoryName",
              width: "25%",
              align: "center"
            },
            {
              title: "单位",
              width: "12%",
              dataIndex: "UnitName",
              align: "center"
            }
          ]
        }
      };
    },
    show() {
      this.visible = true;
    },
    submitGoods() {
      const row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.error("请选择物品！");
        return false;
      }
      this.$emit("submit", row);
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped></style>
